import {deleteRequest, getRequest, postRequest, putRequest} from "../../../../common/helpers/RequestHelper";

class SmartPosService{
    apiListSmartPos = 'api/v1/payment/list_smart_pos' ;
    apiCreateSmartPos = 'api/v1/payment/store_smart_pos' ;
    apiUpdateSmartPos = 'api/v1/payment/update_smart_pos/' ;
    apiDeleteSmartPos = 'api/v1/payment/delete_smart_pos/' ;
    public fetchListSmartPos(params:any): Promise<any> {
        const queryParam = [
            params.per_page ? `per_page=${params.per_page}` : '',
            params.page_number ? `page=${params.page_number}` : '',
            params.search ? `pos_name=${params.search}` : '',
            params.status ? `status=${params.status}` : '',
            params.vendor_name ? `vendor_name=${params.vendor_name}` : '',
        ].filter(Boolean).join('&');
        return getRequest(`${this.apiListSmartPos}?${queryParam}`);
    }
    public fetchCreateSmartPos(params:any): Promise<any>{
        return postRequest(`${this.apiCreateSmartPos}`, params);
    }
    public fetchUpdateSmartPos(params:any,id:number): Promise<any>{
        return putRequest(`${this.apiUpdateSmartPos}${id}`, params);
    }

    public fetchDeleteSmartPos(id:number): Promise<any>{
        return deleteRequest(`${this.apiDeleteSmartPos}${id}`);
    }
}
export const smartPosService = new SmartPosService();